import { WorkoutLibraryWidget } from '@mdvip/shared/features/workout-library/WorkoutLibraryWidget';
import { useTranslation } from 'react-i18next';
import { useWorkoutLibraryConfig } from '@/hooks/resources/useWorkoutLibraryConfig';

export function FitnessPage() {
  const { t } = useTranslation('members');
  const { data: config, isLoading } = useWorkoutLibraryConfig();

  return (
    <>
      <div className="mb-8">
        <h1 className="text-h1 font-semibold">{t('pages.fitness.title')}</h1>
        <p className="text-muted-foreground mt-1">{t('pages.fitness.subtitle')}</p>
      </div>
      {isLoading ? (
        <div className="rounded-lg border border-dashed p-12 text-center">
          <p className="text-muted-foreground">{t('pages.fitness.loading')}</p>
        </div>
      ) : config ? (
        <WorkoutLibraryWidget config={config} />
      ) : (
        <div className="rounded-lg border border-dashed p-12 text-center">
          <p className="text-muted-foreground">{t('pages.fitness.empty')}</p>
        </div>
      )}
    </>
  );
}
